// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"3954":"2c878f8c","9018":"8eb66d90"}[chunkId] + ".css";
};